import React from 'react';
import Toast from 'react-bootstrap/Toast';
import ToastContainer from 'react-bootstrap/ToastContainer';

const AppToast = ({ show, message, variant = 'success', onClose }) => {
  if (!message) return null;

  return (
    <ToastContainer
      position="top-end"
      className="app-toast-container p-3"
      containerPosition="fixed"
    >
      <Toast
        show={show}
        onClose={onClose}
        delay={4000}
        autohide
        bg={variant}
        className="app-toast"
      >
        <Toast.Body className={variant === 'success' ? 'text-white' : undefined}>
          {message}
        </Toast.Body>
      </Toast>
    </ToastContainer>
  );
};

export default AppToast;
